import { newGuid } from 'utils/guid';

export class ComboBoxItem {
  id: string;

  key: number;

  description: string;

  constructor() {
    this.id = newGuid();
    this.key = 0;
    this.description = '';
  }

  isEqual(item: ComboBoxItem) {
    if (item.description !== this.description) return false;
    if (item.key !== this.key) return false;

    return true;
  }
}

export class ComboBoxItemList {
  items: ComboBoxItem[];
  
  default: ComboBoxItem | undefined;

  constructor() {
    this.items = [];
    this.default = undefined;
  }

  clone(): ComboBoxItemList {
    const newList = new ComboBoxItemList();
    newList.default = this.default;

    for (let i = 0; i < this.items.length; i++) {
      const newItem = new ComboBoxItem();
      newItem.id = this.items[i].id;
      newItem.key = this.items[i].key;
      newItem.description = this.items[i].description;
      newList.items.push(newItem);
    }

    return newList;
  }

  getMaxKey(): number {
    if (this.items.length === 0) return 0;

    return Math.max(...this.items.map((o) => o.key));
  }

  isEqual(list: ComboBoxItemList) {
    if (list.default !== this.default) return false;
    if (list.items.length !== this.items.length) return false;

    for (let idx = 0; idx < list.items.length; idx++) {
      const item1 = list.items[idx];
      const item2 = this.items[idx];
      if (!item1.isEqual(item2)) return false;
    }

    return true;
  }
}
